// /Users/zachepilka/radiomonitor-frontend/src/pages/static/TermsPage.en.jsx
import React from 'react';

export default function TermsPageEn() {
  return (
    <div style={{
      maxWidth: 900,
      margin: '0 auto',
      padding: '40px 20px',
      lineHeight: 1.6,
      color: '#1b1b1f'
    }}>
      <h1 style={{ marginBottom: 24, color: '#006b44' }}>Radiomonitor.net Terms of Use</h1>
      <p>
        These Terms of Use (the “Terms”) govern access to and use of the Radiomonitor.net service (the “Service”).
        By accessing or using the Service, you confirm that you agree to these Terms in full.
      </p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>1. General Provisions</h2>
      <p>Radiomonitor.net is an online analytics, monitoring, and automation platform for internet radio broadcasters.</p>
      <p>Access to the Service is granted only after reviewing and accepting these Terms.</p>
      <p>The Service administration may amend the Terms at any time; updates become effective once published on the website.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>2. Provision of Services</h2>
      <p>The Service is delivered on a subscription basis according to the selected pricing plan or a custom agreement.</p>
      <p>Reports and datasets produced by the Service are provided for informational and analytical purposes and are used at the user’s discretion.</p>
      <p>Radiomonitor.net is not liable for external factors (internet outages, third-party tools, etc.) that affect your radio station’s performance.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>3. Limitation of Liability</h2>
      <p>We strive for stable operation yet do not guarantee uninterrupted availability or complete absence of technical faults.</p>
      <p>The Service is not responsible for direct or indirect losses caused by the use of or inability to use Radiomonitor.net features.</p>
      <p>Each user remains responsible for configuring their hardware, software environment, and network connection.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>4. Payment and Subscription</h2>
      <p>Paid functionality becomes available only after the selected plan or package has been successfully paid.</p>
      <p>Payments are processed via supported payment providers, including automated billing when enabled.</p>
      <p>If you discontinue the Service, fees for an active billing period are non-refundable unless otherwise stipulated by contract.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>5. Intellectual Property</h2>
      <p>All content, software components, databases, and interface design belong to Radiomonitor.net or its licensors.</p>
      <p>Copying, distributing, or otherwise using algorithms or statistical materials without written consent is prohibited.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>6. Privacy</h2>
      <p>The Service collects a minimal set of technical data (IP address, connection parameters, usage metrics) required to support functionality.</p>
      <p>Personal data is not shared with third parties except where required by applicable law.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>7. User Data Retention</h2>
      <p>If subscription payments stop, user data is retained for 30 calendar days after the subscription ends.</p>
      <p>After this period the data may be removed without the possibility of recovery.</p>
      <p>Users with uninterrupted paid access for more than one year have their data stored for at least twelve months.</p>
      <p>Upon written request and for an additional fee, the retention period can be extended; specific terms are coordinated with support.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>8. Termination of Access</h2>
      <p>Radiomonitor.net may suspend or restrict access if the user violates these Terms or applicable legal requirements.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>9. Contacts</h2>
      <p>
        For questions or suggestions, please reach out to the Service team:
        <br />
        support@radiomonitor.net
      </p>
    </div>
  );
}
